import i18n from '@/utils/i18n';
export class RequestException extends Error {
    constructor(error) {
        super(error)
        Object.assign(this, error)
    }
}